import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { StatePanel } from "@/components/data-state";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import type { AuthContextValue } from "@/features/auth/auth-provider";
import { errorMessage } from "@/lib/http";
import { AlertTriangleIcon, CompassIcon } from "lucide-react";

export interface RouterContext {
  auth: AuthContextValue;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <TooltipProvider>
      <Outlet />
      <Toaster />
    </TooltipProvider>
  );
}

function RouteError({ error }: { error: unknown }) {
  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <StatePanel
        icon={<AlertTriangleIcon className="text-destructive size-6" />}
        title="Bir şeyler ters gitti"
        description={errorMessage(error)}
        action={
          <Button variant="outline" onClick={() => window.location.reload()}>
            Sayfayı yenile
          </Button>
        }
      />
    </div>
  );
}

function NotFound() {
  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <StatePanel
        icon={<CompassIcon className="text-muted-foreground size-6" />}
        title="Sayfa bulunamadı"
        description="Aradığınız adres taşınmış veya hiç var olmamış olabilir."
        action={
          <Button asChild variant="outline">
            <a href="/">Gösterge paneline dön</a>
          </Button>
        }
      />
    </div>
  );
}
